import { useEffect, useRef } from "react";
import "../index.css";
import { useState, useContext } from "react";
import { UserInfoContext } from "Context/CommonContext";
import { LectureStatus, Segments } from "utilFunctions/Constants/Constants";
import useMasterContext from "Context/MasterContext";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import CourseSubjectListing from "Pages/MyBatches/MyBatch/SharedComponents/CourseSubjectListing";
import { Col, Row, Select, Typography as TY } from "antd";
import DatePickerAntdComponent from "utilFunctions/shared/AntdSharedComponents/DatePickerAntdComponent";
import moment from "moment";
export interface selectInterface {
  label: any;
  key: any;
  value: any;
  region?: any;
  id?: any;
}
export const nullOption = [{ label: "All", key: "all", value: null }];
const { Text } = TY;
const MyBatchFilter = ({
  filterState,
  setFilterState,
  location,
  dateRanges,
  setOpen,
  selectedTab,
  batchDetailById,
  selectedCourseSyllabus,
  setSelectedCourseSyllabus,
  subjects,
  activeTab,
  setDateRanges,
  updateSetItems,
}: any) => {
  const { filterListing } = selectedTab;
  const refOne = useRef<HTMLDivElement>(null);
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const { masters } = useMasterContext();
  const [stream, setStream] = useState<selectInterface[]>(
    masters?.streams ? nullOption.concat(masters.streams) : []
  );
  const [obj, setObj] = useState({
    startDate: moment(dateRanges[0].startDate).format("YYYY-MM-DD"),
    endDate: moment(dateRanges[0].endDate).format("YYYY-MM-DD"),
  });
  const preStreamFilter =
    location?.state?.filterState?.stream != undefined
      ? location?.state?.filterState?.stream
      : masters.streams && masters.streams[0] != undefined
      ? masters.streams[0]
      : null;
  const [filterheadingListing, setfilterheadingListing] = useState([
    {
      name: "Stream",
      nickName: "stream",
      data: stream,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Class",
      nickName: "clazz",
      data: masters?.classes,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Risk Segments",
      nickName: "segment",
      data: Segments,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Status",
      nickName: "status",
      data: LectureStatus,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Subject",
      nickName: "subject",
      data: subjects,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Test Type",
      nickName: "testTypes",
      data: masters.testTypes,
      filterSelectedData: [],
    },
    {
      name: "CouseSubject",
      nickName: "CourseSubject",
      data: batchDetailById,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Type",
      nickName: "lectureType",
      data: [
        {
          value: "Lectures",
          label: "Lectures",
        },
        {
          value: "Non Lecture",
          label: "Non Lecture",
        },
      ],
      filterSelectedData: [],
    },
    {
      name: "Type",
      nickName: "testType",
      data: [
        {
          value: "Upcoming Tests",
          label: "Upcoming Tests",
        },
        {
          value: "Past Tests",
          label: "Past Tests",
        },
      ],
      filterSelectedData: [],
    },
  ]);
  useEffect(() => {
    setfilterheadingListing([
      {
        name: "Stream",
        nickName: "stream",
        data: stream,
        singleSelect: true,
        filterSelectedData: [],
      },
      {
        name: "Class",
        nickName: "clazz",
        data: masters?.classes,
        singleSelect: true,
        filterSelectedData: [],
      },
      {
        name: "Risk Segments",
        nickName: "segment",
        data: Segments,
        singleSelect: true,
        filterSelectedData: [],
      },
      {
        name: "Status",
        nickName: "status",
        data: LectureStatus,
        singleSelect: true,
        filterSelectedData: [],
      },
      {
        name: "Subject",
        nickName: "subject",
        data: subjects,
        singleSelect: true,
        filterSelectedData: [],
      },
      {
        name: "Test Type",
        nickName: "testTypes",
        data: masters.testTypes,
        singleSelect: true,
        filterSelectedData: [],
      },
      {
        name: "CourseSubject",
        nickName: "CourseSubject",
        data: batchDetailById,
        singleSelect: false,
        filterSelectedData: [],
      },
      {
        name: "Type",
        nickName: "lectureType",
        singleSelect: true,
        data: [
          {
            value: "Lectures",
            label: "Lectures",
            key: "Lectures",
          },
          {
            value: "Non Lecture",
            label: "Non Lecture",
            key: "Non Lecture",
          },
        ],
        filterSelectedData: [],
      },
      {
        name: "Type",
        nickName: "uptestType",
        singleSelect: true,
        data: [
          {
            value: "Upcoming Tests",
            label: "Upcoming Tests",
            key: "Upcoming Tests",
          },
          {
            value: "Past Tests",
            label: "Past Tests",
            key: "Past Tests",
          },
        ],
        filterSelectedData: [],
      },
    ]);
  }, [batchDetailById, activeTab]);
  useEffect(() => {
    setStream(userInfo?.userStreams as any);
  }, [userInfo, masters?.streams]);

  const handleAddFilterArrayList = (name: string, val: any) => {
    if (["lectureType"].includes(name)) {
      updateSetItems(val);
    }
    const data = filterheadingListing.find(
      (ele: any) => ele.nickName == name
    )?.data;
    const fieldName = data.find((ele: any) => ele.value == val)?.label;
    setFilterState((prevState: any) => ({
      ...prevState,
      [name]: val,
      chipFieldName: {
        ...prevState.chipFieldName,
        [name]: fieldName,
      },
    }));
  };

  const filterStateCopy = { ...filterState };
  if (preStreamFilter?.label == filterStateCopy?.stream?.label) {
    delete filterStateCopy["stream"];
  }
  const selectedCourseSyllabusHandler = (item: any) => {
    setSelectedCourseSyllabus(item);
  };
  const returnFilter = (ele: any) => {
    if (filterListing.includes(ele.nickName)) {
      if (ele.singleSelect) {
        return (
          <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
            <Text>{ele.name}</Text>
            <Select
              placeholder={ele.name}
              style={{ width: "100%", marginTop: "16px" }}
              size="large"
              allowClear
              options={ele.data}
              value={
                filterState[ele.nickName] ? filterState[ele.nickName] : null
              }
              onChange={(selected: any) => {
                handleAddFilterArrayList(ele.nickName, selected);
              }}
            />
          </Col>
        );
      } else {
        if (ele?.nickName == "CourseSubject") {
          return (
            <Col
              xxl={24}
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className="d-flex justify-content-end"
            >
              {ele.data && ele.data.length ? (
                <div className="d-flex justify-content-end">
                  <CourseSubjectListing
                    item={ele.data}
                    selectedCourseSyllabus={selectedCourseSyllabus}
                    selectedCourseSyllabusHandler={
                      selectedCourseSyllabusHandler
                    }
                  ></CourseSubjectListing>
                </div>
              ) : null}
            </Col>
          );
        }
        return null;
      }
    } else {
      return null;
    }
  };
  const hideOnEscape = (e: any) => {
    if (e.key === "Escape") {
      setOpen(false);
    }
  };
  const hideOnClickOutside = (e: any) => {
    if (refOne.current) {
      if (!refOne.current.contains(e.target)) {
        setOpen(false);
      }
    }
  };
  useEffect(() => {
    document.addEventListener("keydown", hideOnEscape, true);
    document.addEventListener("click", hideOnClickOutside, true);
  }, []);

  useEffect(() => {
    if (dateRanges) {
      setObj({
        startDate: moment(dateRanges[0].startDate).format("YYYY-MM-DD"),
        endDate: moment(dateRanges[0].endDate).format("YYYY-MM-DD"),
      });
    }
  }, [dateRanges]);
  return (
    <Row gutter={[10, 16]}>
      {filterheadingListing.map((ele: any) => returnFilter(ele))}
      {filterListing.includes("date") && (
        <Col span={24}>
          <Text>Date Range</Text>
          <div className="mt-3">
            <DatePickerAntdComponent
              dateRanges={obj}
              dateSetHandler={(obj: any) => {
                setDateRanges([
                  {
                    startDate: obj.startDate,
                    endDate: obj.endDate,
                    key: "selection",
                  },
                ]);
                setFilterState({
                  ...filterState,
                  ...obj,
                  chipFieldName: {
                    ...filterState.chipFieldName,
                    ...obj,
                  },
                });
              }}
            ></DatePickerAntdComponent>
          </div>
        </Col>
      )}
    </Row>
  );
};
export default MyBatchFilter;
